require('../../modules/es6.object.is');
module.exports = require('../../modules/_core').Object.is;


//////////////////
// WEBPACK FOOTER
// ./~/react-helmet/~/core-js/fn/object/is.js
// module id = 780
// module chunks = 0